import type { LucideIcon, LucideProps } from 'lucide-react'
import { forwardRef } from 'react'

export const BriefcaseFilled: LucideIcon = forwardRef<SVGSVGElement, LucideProps>(({ size = 24, ...props }, ref) => {
  return (
    <svg
      ref={ref}
      width={size}
      height={size}
      viewBox="0 0 22 19"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M19.6686 3.53332H14.9631V1.63726C14.9631 0.734444 14.2287 0 13.3258 0H8.52169C7.61888 0 6.88439 0.734444 6.88439 1.63726V3.53332H2.17895C0.980277 3.53332 0.00504839 4.50855 0.00504839 5.70723C0.00504839 6.79605 -0.106459 7.77387 0.718647 8.87353C1.18548 9.49568 1.82701 9.9395 2.57385 10.1569L9.82615 12.2685C10.5441 12.4775 11.3032 12.4776 12.0213 12.2685L19.2736 10.1569C20.0204 9.93946 20.662 9.49568 21.1288 8.87353C21.9576 7.76893 21.8424 6.78105 21.8424 5.70723C21.8424 4.50855 20.8673 3.53332 19.6686 3.53332ZM8.2712 1.63726C8.2712 1.49914 8.38357 1.38681 8.52169 1.38681H13.3258C13.464 1.38681 13.5763 1.49918 13.5763 1.63726V3.53332H8.2712V1.63726Z"
        fill="currentColor"
      />
      <path
        d="M19.6611 11.4885C11.8386 13.766 11.9399 13.8121 10.9236 13.8121C9.91448 13.8121 10.1539 13.8084 2.18603 11.4885C1.34592 11.2439 0.601903 10.793 0.00488281 10.1714V16.8262C0.00488281 18.0248 0.980068 19 2.17879 19H19.6684C20.867 19 21.8423 18.0248 21.8423 16.8262V10.1714C21.2452 10.7929 20.5012 11.2439 19.6611 11.4885Z"
        fill="currentColor"
      />
    </svg>
  )
})

BriefcaseFilled.displayName = 'BriefcaseFilled'
